export const GET_METRICS_ATTEMPT = 'GET_METRICS_ATTEMPT';
export type GET_METRICS_ATTEMPT = typeof GET_METRICS_ATTEMPT;

export const GET_METRICS_SUCCESS = 'GET_METRICS_SUCCESS';
export type GET_METRICS_SUCCESS = typeof GET_METRICS_SUCCESS;

export const GET_METRICS_FAILURE = 'GET_METRICS_FAILURE';
export type GET_METRICS_FAILURE = typeof GET_METRICS_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/metrics/get/Types.tsx